import React from 'react';
import styles from './image.module.scss';
import { ElementDto } from 'api';
import { EditControlsType, SaveType } from 'modules/course/course.types';
import { ImageEdit } from './ImageEdit';
import { ImageView } from './ImageView';
import { ActionTypes } from 'modules/course/state/actions/course/types';
import { useClassName } from 'hooks/use-class-name';

const Wrapper = ({
	children,
	userCanEdit,
}: {
	children: React.ReactNode;
	userCanEdit?: boolean;
}) => {
	const classNames = useClassName(
		styles.text,
		userCanEdit && styles.editable,
	);

	return <div className={classNames}>{children}</div>;
};

interface IImage {
	chapterId: string;
	pageId: string;
	element: ElementDto;
	editControls: EditControlsType;
	save: SaveType;
	changeElement: ActionTypes['changeElement'];
	deleteElement: ActionTypes['deleteElement'];
}

export function Image({
	chapterId,
	pageId,
	element,
	editControls,
	save,
	changeElement,
	deleteElement,
}: IImage) {
	const { setEditMode, leaveEditMode, editMode, userCanEdit } = editControls(
		element.id,
	);

	const handleChangeElement = (content: string) => {
		changeElement(chapterId, pageId, element.id, content);
	};

	const handleDeleteElement = () => {
		deleteElement(chapterId, pageId, element.id);
		save(element.id);
	};

	if (editMode) {
		return (
			<Wrapper>
				<ImageEdit
					name={element.id}
					element={element}
					changeElement={handleChangeElement}
					deleteElement={handleDeleteElement}
					leaveEditMode={leaveEditMode}
					save={save}
					withDescription
				/>
			</Wrapper>
		);
	}

	return (
		<Wrapper userCanEdit={userCanEdit}>
			<ImageView
				userCanEdit={userCanEdit}
				setEditMode={setEditMode}
				element={element}
				name={element.id}
			/>
		</Wrapper>
	);
}
